import {
	getApiUrl,
	getDocumentIdContentV2Path,
} from "web_myplann/Infrastructure/Api/Api";
import {
	blobToBase64,
	parseFilenameFromContentDisposition,
} from "web_myplann/Infrastructure/Utils/FileUtils";
import { fetchAuthorized } from "web_myplann/Shared/Utils/fetchAuthorized";

export type DownloadedDocumentContent = {
	blob: Blob;
	base64: string;
	filename: string;
	mimeType?: string;
};

export type DownloadDocumentContentParams = {
	id: number;
	fallbackTitle?: string;
	token: string;
	tokenVerify: string;
	authorizationType?: string;
	errorMessage: string;
};

export const downloadDocumentContent = async ({
	id,
	fallbackTitle,
	token,
	tokenVerify,
	authorizationType,
	errorMessage,
}: DownloadDocumentContentParams): Promise<DownloadedDocumentContent> => {
	const response = await fetchAuthorized({
		url: `${getApiUrl()}${getDocumentIdContentV2Path(id)}`,
		credentials: { token, tokenVerify, authorizationType },
		errorMessage,
	});

	const blob = await response.blob();
	const base64 = await blobToBase64(blob);
	const filename =
		parseFilenameFromContentDisposition(
			response.headers.get("Content-Disposition"),
		) ??
		fallbackTitle ??
		"";
	const mimeType = response.headers.get("Content-Type") ?? undefined;

	return { blob, base64, filename, mimeType };
};
